import React from 'react';
import { render } from 'react-dom';

import { loadLang } from '../../../lang';

import DealLabelFramed from './DealLabelFramed.jsx';

function setDealLabelFramed(room, containerId) {
    let labelType;
    let lang = {};
    loadLang(['common'])
    // eslint-disable-next-line max-statements
    .then((language) => {
        lang = language;
        if (Number(room.review_score) > 4.5 &&
        room.review_count > 10 && Number(room.hourly_rate) > 30) {
            labelType = 2;
        }
        if (room.last_booked) {
            const date = moment(room.last_booked);
            const today = moment();
            const sevenDaysAgo = today.clone().subtract(7, 'days').startOf('day');
            if (date.isAfter(sevenDaysAgo)) {
                labelType = 3;
            }
        }
        let text;
        let className;
        let glyphicon;
        switch (labelType) {
        case 2:
            text = 'common_highly_rated';
            className = 'highly-rated';
            glyphicon = 'star';
            break;
        case 3:
            text = 'common_best_seller';
            className = 'regularly-booked';
            glyphicon = 'certificate';
            break;
        case 4:
            text = 'common_excellent_deal';
            className = 'excellent-deal';
            glyphicon = 'fire';
            break;
        default:
            return;
        }
        if (labelType) {
            const container = document.querySelector(`#${containerId}`);
            render(
                <DealLabelFramed
                    className={className}
                    glyphicon={glyphicon}
                    text={lang.common[text]}
                />
            , container);
        }
    })
    // eslint-disable-next-line no-console
    .catch(console.log);
}

export {
    DealLabelFramed,
    setDealLabelFramed
};



// WEBPACK FOOTER //
// ./common/components/deal_label_framed/index.js